import { GET_PUBLIC_TOKEN, GET_PUBLIC_TOKEN_ERROR, GET_PUBLIC_TOKEN_SUCCESS } from './AuthenticationProvider.actions'

const authenticationProviderState = {
  publicToken: {
    loading: true,
    error: undefined
  }
}

/**
 * The authentication provider's reducer.
 */
const authenticationProviderReducer = (state = authenticationProviderState, { payload, type }) => {
  switch (type) {
    case GET_PUBLIC_TOKEN: {
      return { ...state, publicToken: { ...state.publicToken, loading: true } }
    }
    case GET_PUBLIC_TOKEN_ERROR: {
      return { ...state, publicToken: { error: payload.error, loading: false } }
    }
    case GET_PUBLIC_TOKEN_SUCCESS: {
      return { ...state, publicToken: { ...state.publicToken, loading: false } }
    }
    default: {
      return state
    }
  }
}

export default authenticationProviderReducer
